export default [
    {
        path: '/cash-desk/my-daily-balance/list',
        name: 'cash_desk_my_daily_balance_list',
        component: () => import('@src/cash-desk/daily-balance/my-daily-balance-list.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'Meine Tagesabschlüsse',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/daily-balance/list',
        name: 'cash_desk_daily_balance_list',
        component: () => import('@src/cash-desk/daily-balance/daily-balance-list.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'Alle Tagesabschlüsse',
            role: 'ROLE_CASH_DESK_LIST_DAILY_BALANCE',
        },
    },
    {
        path: '/cash-desk/daily-balance/:id?',
        name: 'daily_balance',
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/cash-desk/daily-balance/daily-balance-report-view.vue'),
        meta: {
            role: 'ROLE_CASH_DESK_SHOW_DAILY_BALANCE',
        },
    },
    {
        path: '/cash-desk/daily-balance/current',
        name: 'current_daily_balance',
        component: () => import('@src/cash-desk/daily-balance/current-daily-balance-report.vue'),
        meta: {
            title: 'Zwischenbericht (X-Bon)',
            role: 'ROLE_CASH_DESK_X_BON',
        },
    },
    {
        path: '/cash-desk/daily-balance/finish',
        name: 'finish_daily_balance',
        component: () => import('@src/cash-desk/daily-balance/daily-balance-checklist.vue'),
        meta: {
            title: 'Tagesabschluss durchführen',
            role: 'ROLE_CASH_DESK',
        },
    },
];
